import $ from 'jquery';
const MAX_COMPARE_COUNT = 6;
const ONE = 1;
const MIN_COMPARE_COUNT = 2;
const FAVOURITES_PER_PAGE = 6;
const VIEW_STATES = {
	FAVOURITES: 'favourites',
	TABLE: 'table'
};

export const CompareComponent = {
	templateUrl: 'compare.html',
	transclude: true,
	controller: class CompareComponent {
		/**
		 * INIT
		 */
		constructor(CommonConstants, $rootScope, favouriteService, RealEstateHandlerService, messagingService,
					notificationService, $scope, $filter, $timeout) {
			'ngInject';
			this.CommonConstants = CommonConstants;
			this.$rootScope = $rootScope;
			this.favouriteService = favouriteService;
			this.checkedList = [];
			this.MAX_COMPARE_COUNT = MAX_COMPARE_COUNT;
			this.ONE = ONE;
			this.MIN_COMPARE_COUNT = MIN_COMPARE_COUNT;
			this.VIEW_STATES = VIEW_STATES;
			this.realEstateService = RealEstateHandlerService;
			this.messagingService = messagingService;
			this.$scope = $scope;
			this.notificationService = notificationService;
			this.$filter = $filter;
			this.$timeout = $timeout;
		}

		$onInit() {
			this.isLoggedIn = this.$rootScope.isLoggedIn;
			if (this.isLoggedIn || window.location.hash && (window.location.hash != '#/' && window.location.hash != '#')) {
				if (window.location.hash && (window.location.hash != '#/' && window.location.hash != '#')) {
					if (/#\/.+/.test(window.location.hash)) {
						this.checkedList = window.location.hash.substr(2).split(',');
						if (this.checkedList.length <= MAX_COMPARE_COUNT && this.checkedList.length >= MIN_COMPARE_COUNT) {
							this.compare();
						} else {
							window.location.href = window.location.href.split('#')[0];
						}
					} else {
						window.location.href = window.location.href.split('#')[0];
					}
				} else if (this.isLoggedIn) {
					this.initFavouritesView();
				}
			} else {
				// todo redirect pl kedvencekre, ott be tud loginolni, lehet h nem is lesz elérhető ez az oldal
				// nem bejelentkezett usereknek
			}
			this.initIsInViewport();
		}

		/**
		 * RESTS
		 */
		getFavourites(params) {
			let vm = this;
			this.favouriteService.getFavourites(params).then((response) => {
				this.responseData = response.data;
				this.favList = response.data.content;
				this.favList.forEach(e => {
					e.property.images = this.$filter('picOrderFilter')(e.property.images);
				});
				this.size = this.responseData.size;
				this.checkSelection();
				vm.initSliders();
			}).catch((err) => {
				this.notificationService.showError({
					message: 'technicalError'
				});

				// mock
				/*
				this.responseData = {content:[{id:31, createDateTime:'2018-07-16 06:07:54', comment:null, property:{comissionId:'M82817', comissionType:'toSell', city:'Salgótarján', district:null, address:'fő út mellet', priceHuf:13900000, area:135.0, siteArea:1455.0, numberOfRooms:5, numberOfHalfRooms:1, lat:48.096226128770674, lng:19.78172859160444, hasHiddenAddress:true, url:'/ingatlan/M82817/elado-csaladi-haz-3102-salgotarjan-fo-ut-mellet', priceChange:null, images:[], offers:[], seen:true, liked:false, likedMorePeople:false, active:true}}, {id:29, createDateTime:'2018-07-16 05:52:23', comment:null, property:{comissionId:'M110093', comissionType:'toSell', city:'Érd', district:null, address:'Postástelep', priceHuf:25500000, area:48.4, siteArea:null, numberOfRooms:3, numberOfHalfRooms:2, lat:47.395701, lng:18.911265, hasHiddenAddress:true, url:'/ingatlan/M110093/elado-lakas-2030-erd-postastelep', priceChange:null, images:[], offers:[], seen:false, liked:false, likedMorePeople:false, active:true}}, {id:28, createDateTime:'2018-07-16 05:52:19', comment:null, property:{comissionId:'M109958', comissionType:'toSell', city:'Érd', district:null, address:'Postástelep', priceHuf:25900000, area:50.6, siteArea:null, numberOfRooms:2, numberOfHalfRooms:1, lat:47.395701, lng:18.911265, hasHiddenAddress:true, url:'/ingatlan/M109958/elado-lakas-2030-erd-postastelep', priceChange:null, images:[], offers:[], seen:false, liked:false, likedMorePeople:false, active:true}}], number:0, numberOfElements:3, totalElements:3, totalPages:1, size:5};
				this.favList = this.responseData.content;
				this.size = this.responseData.size;
				this.checkSelection();

				this.favList[0].property.images = [{
					url: '/static/assets/sitebuild/img/career-01.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/career-02.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/career-03.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.realestate.com.au/blog/images/1885x1414-fit,progressive/2018/02/26012408/investing-property-with-superannuation_2000x1500.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}];

				this.favList[1].property.images = [{
					url: '/static/assets/sitebuild/img/ingatlan-02.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-03.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-04.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-05.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}];

				this.favList[2].property.images = [{
					url: 'https://www.hindustantimes.com/rf/image_size_640x362/HT/p2/2016/11/15/Pictures/dream-house-front_8843d09c-ab15-11e6-b961-04ee4fa7b706.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://cms.homeaway.com/files/live/sites/hub/files/contributed/homepage/marketing/list-your-property.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://d27p8o2qkwv41j.cloudfront.net/wp-content/uploads/2017/08/shutterstock_516637903-e1504758036917.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}];
				vm.initSliders();
				*/

			});
		}

		// Lazy slider
		initSliders() {
			let vm = this;
			if (this.favList && angular.element('.m14-slick_' + this.favList[0].property.comissionId).length) {
				this.favList.forEach(e => {
					vm.lazyBgImg(true, 0, e);
					angular.element('.m14-slick_' + e.property.comissionId).on('init', (event, slick) => {
						vm.lazyBgImg(angular.element(slick.$slides.get(0)), 0, e);
					});
					angular.element('.m14-slick_' + e.property.comissionId).on('beforeChange', (event, slick, slide, nextSlide) => {
						if (nextSlide != slide) {
							vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide)), nextSlide, e);
						}
					});
				});
			} else {
				vm.$timeout(() => {
					vm.initSliders();
				}, 300);
			}
		}

		lazyBgImg(element, nextSlide, e) {
			if (element) {
				let lazyBgImgs = angular.element('.m14-slick_' + e.property.comissionId + '_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + e.property.images[nextSlide].url + ')');
				});
			}
		}

		compare() {
			this.setHash();
			window.dataLayer.push({
				event: 'propertyComparison',
				comparedPropertyNo: this.checkedList.length
			});
			let params = {
				comissionIds: this.checkedList.join(',')
			};
			this.realEstateService.compare(params).then((response) => {
				this.setCompareData(response.data);
			}).catch(() => {
				this.initFavouritesView();
				this.notificationService.showError({
					message: 'technicalError'
				});
			});
		}

		/**
		 * PAGING
		 */
		loadPage(event) {
			this.pager(event.pageTo, this.size);
		}

		pager(page, size) {
			let params = {
				page: page,
				size: size
			};
			this.getFavourites(params);
		}

		/**
		 * UTIL
		 */
		checkSelection() {
			this.favList.forEach((element) => {
				element.isChecked = this.checkIsSelected(element.property.comissionId) > -1;
			});
		}

		checkIsSelected(comissionId) {
			return this.checkedList.indexOf(comissionId);
		}

		setFavCompare(comissionId) {
			let index = this.checkIsSelected(comissionId);
			if (index > -1) {
				this.checkedList.splice(index, 1);
			} else {
				this.checkedList.push(comissionId);
			}
		}

		removeSelections() {
			this.checkedList = [];
			this.favList.forEach((element) => {
				element.isChecked = false;
			});
		}

		setHash() {
			window.location.hash = '/' + this.checkedList.join(',');
		}

		setCompareData(values) {
			this.comparedProperties = [];
			for (let i = 0; i < values.length; i++) {
				values[i].images = this.$filter('picOrderFilter')(values[i].images);
				this.comparedProperties.push(values[i]);
			}
			this.compareView = VIEW_STATES.TABLE;
		}

		initFavouritesView() {
			this.getFavourites({page: 0, size: FAVOURITES_PER_PAGE});
			this.compareView = VIEW_STATES.FAVOURITES;
		}

		initIsInViewport() {
			let self = this; // angular ctrl
			$.fn.isInViewport = function () {
				let elementTop = $(this).offset().top;
				let elementBottom = elementTop + $(this).outerHeight();

				let viewportTop = $(window).scrollTop();
				let viewportBottom = viewportTop + $(window).height();

				return elementBottom > viewportTop && elementTop < viewportBottom;
			};
			$('.ip-content-container').on('resize scroll', function (e) {
				$('.m14-compare-sticky--not-fixed').each(function () {
					if ($(this).isInViewport()) {
						self.isStickyVisible = false;
					} else {
						if ($(this).position().top > window.pageYOffset) {
							self.isStickyVisible = true;
						}
					}
					self.$scope.$apply();
				});
			});
		}

		/**
		 * SHARE
		 */

		sendShareEmail($event) {
			let params = {
				name: $event.share.name,
				url: window.location.href,
				emailAddress: $event.share.emailAddress,
				lang: $event.share.lang,
				from: $event.share.from
			};
			this.messagingService.sendMessageToPerson(params, $event.share.captcha).then(() => {
				this.shareResponse = true;
			});
		}

		print() {
			this.analytics.sendEvent('Ingatlan összehasonlítás', 'Nyomtatás', null);
			window.print();
		}

		newSearch($event) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = angular.element($event.target).attr('href');
			}, 500);
			this.analytics.sendEvent('Ingatlan összehasonlítás', 'Új keresés');
		}
	}
};
